// Получаем данные о геолокации пользователя
export const getLocationPromise = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      position => resolve(position),
      error => reject(error)
    )
  })

export const handleGeolocationError = error => {
  let errorStr

  switch (error.code) {
    case error.PERMISSION_DENIED:
      errorStr = 'Клиент ограничил доступ к геолокации'
      break
    case error.POSITION_UNAVAILABLE:
      errorStr = 'Информация о геолокации недоступна'
      break
    case error.TIMEOUT:
      errorStr = 'Превышено время ожидания для геолокации'
      break
    case error.UNKNOWN_ERROR:
      errorStr = 'Неизвестная ошибка'
      break
    default:
      errorStr = 'Неизвестная ошибка'
  }

  return errorStr
}

export const showGeolocationPosition = position => [
  position.coords.latitude,
  position.coords.longitude,
]
